module.exports = __webpack_public_path__ + "img/any-bg10.c966d212.png";